
<script>
export default {
  props: {
    securedLink: {
      type: String,
      required: true
    },
    component: {
      type: [Object, Function],
      required: true
    }
  },
  emits: ["download"],
  data() {
    return {
      error: null
    };
  },
  methods: {
    async download() {
      this.$emit("download");
      const opener = window.open("", "_blank");
      try {
        const res = await this.$apiDrive.get(this.securedLink);
        if (res.data.url) {
          opener.location = res.data.url;
        } else {
          opener.close();
          this.error = "Impossible d'ouvrir ce document pour le moment.";
        }
      } catch (error) {
        opener.close();
        this.error = this.$apiDrive.getErrorData(error);
      }
    }
  }
};
</script>

<template>
  <div>
    <component
      :is="component"
      v-bind="removeClassAndStyleFromAttrs($attrs)"
      @click="download"
    >
      <slot />
    </component>
    <template v-if="error">
      <br />
      <span class="u-color-alert u-font-12">
        {{ error }}
      </span>
    </template>
  </div>
</template>
